// extracted by mini-css-extract-plugin
export default {"buttonBg":"Button_buttonBg__+gYLf","successBg":"Button_successBg__q-cXQ","container":"Button_container__gmwQj","successImg":"Button_successImg__BgDM4","text":"Button_text__f8zsH"};